import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private requests = 0;
  private loaderSubject = new BehaviorSubject<boolean>(false);
  loader$ = this.loaderSubject.asObservable();

  show() {
    this.requests++;
    this.loaderSubject.next(true);
  }

  hide() {
    this.requests = Math.max(this.requests - 1, 0);
    if (this.requests === 0) {
      this.loaderSubject.next(false);
    }
  }
}
